export const DEFAULT_CACHE_TTL = 2 * 7 * 24 * 60 * 60 * 1000
